module.exports = __webpack_public_path__ + "static/media/bar-line.5e613aac.svg";